import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';

export default function NewProjectPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: '', description: '', category: '',
    programmingLanguages: '', deploymentType: '', teamSize: '',
  });
  const [loading, setLoading] = useState(false);

  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = {
        ...form,
        teamSize: form.teamSize ? parseInt(form.teamSize) : undefined,
        programmingLanguages: form.programmingLanguages.split(',').map(s => s.trim()).filter(Boolean),
      };
      const { data } = await axios.post('/api/projects', payload);
      toast.success('Progetto creato!');
      navigate(`/dashboard/projects/${data.id}/questionnaire`);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Errore nella creazione');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="topbar">
        <span className="topbar-title">Nuovo progetto</span>
      </div>
      <div className="page-content">
        <div style={{ maxWidth: 620 }}>
          <div style={{ marginBottom: 24 }}>
            <p style={{ color: '#5C5B55' }}>Inserisci i dati del software da certificare. Dopo la creazione, verrai guidato nel questionario ESG.</p>
          </div>
          <div className="card">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Nome del progetto / software *</label>
                <input className="form-control" required placeholder="es. GestionalePro 3.0" value={form.name} onChange={set('name')} />
              </div>
              <div className="form-group">
                <label>Descrizione</label>
                <textarea className="form-control" rows={3} placeholder="Breve descrizione del software, funzionalità principali e utilizzo..." value={form.description} onChange={set('description')} />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div className="form-group">
                  <label>Categoria</label>
                  <select className="form-control" value={form.category} onChange={set('category')}>
                    <option value="">Seleziona...</option>
                    <option>Web Application</option>
                    <option>Mobile App</option>
                    <option>API / Backend</option>
                    <option>ERP / Gestionale</option>
                    <option>E-commerce</option>
                    <option>SaaS</option>
                    <option>Embedded / IoT</option>
                    <option>AI / ML</option>
                    <option>Altro</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Deploy</label>
                  <select className="form-control" value={form.deploymentType} onChange={set('deploymentType')}>
                    <option value="">Seleziona...</option>
                    <option value="cloud">Cloud</option>
                    <option value="on-premise">On-premise</option>
                    <option value="hybrid">Ibrido</option>
                    <option value="saas">SaaS</option>
                  </select>
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 12 }}>
                <div className="form-group">
                  <label>Linguaggi di programmazione</label>
                  <input className="form-control" placeholder="es. Python, React, Node.js (separati da virgola)" value={form.programmingLanguages} onChange={set('programmingLanguages')} />
                </div>
                <div className="form-group">
                  <label>Dimensione team (n. persone)</label>
                  <input className="form-control" type="number" min="1" placeholder="es. 8" value={form.teamSize} onChange={set('teamSize')} />
                </div>
              </div>
              <div style={{ display: 'flex', gap: 10, marginTop: 8 }}>
                <button type="button" className="btn btn-outline" onClick={() => navigate('/dashboard')}>Annulla</button>
                <button className="btn btn-primary" disabled={loading}>
                  {loading ? 'Creazione...' : 'Crea e inizia il questionario →'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
